export default __webpack_public_path__ + "static/hero-bg2-mobile-276ba23d5b9b29f8729cb312dce9b821.jpg";